import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'mfp-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true
    }
  ]
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() disabled = false;
  @Input() label = '';

  private innerValue = false;

  constructor() {}

  // ControlValueAccessor
  private onChangeCallback = (_: boolean) => {};
  private onTouchCallback = () => {};

  get value(): boolean {
    return this.innerValue;
  }

  set value(value: boolean) {
    if (value !== this.innerValue) {
      this.innerValue = value;
      this.onChangeCallback(value);
      this.onTouchCallback();
    }
  }

  writeValue(value: boolean): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: (_: boolean) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchCallback = fn;
  }

  setDisabledState(state: boolean): void {
    this.disabled = state;
  }
}
